import SectionsData from "modules/shared/profiles/SectionsData";
import { SectionContainer } from "modules/shared/profiles/ViewPaymentInfo";
import React from "react";
import styled from "styled-components";

const Label = styled.span`
    font-size: 16px;
    color: #98a2b3;
    margin-bottom: 15px;
    font-weight: 400;
`;
function ViewCompanyInfo({ supplierData }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Company Name"
                text={
                    supplierData?.companyName ? supplierData?.companyName : <Label>No data</Label>
                }
            />
            <SectionsData
                label="Commercial Registration"
                image={supplierData?.commercialRegister}
            />
            <SectionsData
                label="Tax Card"
                image={supplierData?.taxCard}
            />
        </SectionContainer>
    );
}

export default ViewCompanyInfo;
